import { CurrencyTokenSymbol } from '../data/currency-tokens/currency-tokens';
import { appEnv } from '../env';
export function checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, tokenAddress, amount) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (!user || !balances || !selectedWallet) {
        return false;
    }
    var balanceMpc = (_a = balances.cta) === null || _a === void 0 ? void 0 : _a.find(function (balance) { return balance.token_address === tokenAddress; });
    var countMpc = balanceMpc ? ((_c = (_b = parseCurrencyQuantity(balanceMpc.balance, balanceMpc.token_address)) === null || _b === void 0 ? void 0 : _b.base) === null || _c === void 0 ? void 0 : _c.value) || 0 : 0;
    if (tokenAddress === appEnv.ctaTokenAddress) {
        countMpc = countMpc - parseFloat(user.ctaTokenCountMpcLocked) / 10000000000;
    }
    var balanceGame = (_d = balances.game) === null || _d === void 0 ? void 0 : _d.find(function (balance) { return balance.token_address === tokenAddress; });
    var countGame = balanceGame
        ? ((_f = (_e = parseCurrencyQuantity(balanceGame.balance, balanceGame.token_address)) === null || _e === void 0 ? void 0 : _e.base) === null || _f === void 0 ? void 0 : _f.value) || 0
        : 0;
    var balanceCustom = (_g = balances.custom) === null || _g === void 0 ? void 0 : _g.find(function (balance) { return balance.token_address === tokenAddress; });
    var countCustom = balanceCustom
        ? ((_j = (_h = parseCurrencyQuantity(balanceCustom.balance, balanceCustom.token_address)) === null || _h === void 0 ? void 0 : _h.base) === null || _j === void 0 ? void 0 : _j.value) || 0
        : 0;
    var balanceLocal = (_k = balances.local) === null || _k === void 0 ? void 0 : _k.find(function (balance) { return balance.token_address === tokenAddress; });
    var countLocal = balanceLocal
        ? ((_m = (_l = parseCurrencyQuantity(balanceLocal.balance, balanceLocal.token_address)) === null || _l === void 0 ? void 0 : _l.base) === null || _m === void 0 ? void 0 : _m.value) || 0
        : 0;
    var amountFormated = ((_p = (_o = parseCurrencyQuantity(amount, tokenAddress)) === null || _o === void 0 ? void 0 : _o.base) === null || _p === void 0 ? void 0 : _p.value) || 0;
    var result = false;
    if (selectedWallet.address === user.mpcWalletAddress) {
        result = amountFormated <= countMpc;
    }
    else if (selectedWallet.address === user.magicLinkWalletAddress) {
        result = amountFormated <= countGame;
    }
    else if (selectedWallet.address === user.coldWalletAddress) {
        result = amountFormated <= countCustom;
    }
    else if (selectedWallet.address === localWalletAddress) {
        result = amountFormated <= countLocal;
    }
    return result;
}
export function getParsedBalances(tokens, parseCurrencyQuantity, balance, lockedCtaTokenValue) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h;
    var ctaTokenBalance = balance.find(function (item) { return item.symbol === CurrencyTokenSymbol.CTA; });
    var parsedCtaBalance = ctaTokenBalance
        ? parseCurrencyQuantity(ctaTokenBalance.balance, appEnv.ctaTokenAddress)
        : undefined;
    var availableCtaTokenValue = (parsedCtaBalance === null || parsedCtaBalance === void 0 ? void 0 : parsedCtaBalance.base) && lockedCtaTokenValue
        ? (parsedCtaBalance.base.value - Number.parseFloat(lockedCtaTokenValue) / 10000000000).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 4,
            roundingMode: 'floor',
        })
        : undefined;
    var usdcAddress = (_b = tokens === null || tokens === void 0 ? void 0 : tokens.find(function (token) { return token.symbol === CurrencyTokenSymbol.USDC; })) === null || _b === void 0 ? void 0 : _b.token_address;
    var usdcBalance = balance.find(function (item) { return item.symbol === CurrencyTokenSymbol.USDC; });
    var parsedUsdcBalance = usdcBalance && usdcAddress ? parseCurrencyQuantity(usdcBalance.balance, usdcAddress) : undefined;
    var imxAddress = (_c = tokens === null || tokens === void 0 ? void 0 : tokens.find(function (token) { return token.symbol === CurrencyTokenSymbol.IMX; })) === null || _c === void 0 ? void 0 : _c.token_address;
    var imxBalance = balance.find(function (item) { return item.symbol === CurrencyTokenSymbol.IMX; });
    var parsedImxBalance = imxBalance && imxAddress ? parseCurrencyQuantity(imxBalance.balance, imxAddress) : undefined;
    var ethAddress = (_d = tokens === null || tokens === void 0 ? void 0 : tokens.find(function (token) { return token.symbol === CurrencyTokenSymbol.ETH; })) === null || _d === void 0 ? void 0 : _d.token_address;
    var ethBalance = balance.find(function (item) { return item.symbol === CurrencyTokenSymbol.ETH; });
    var parsedEthBalance = ethBalance && ethAddress !== undefined ? parseCurrencyQuantity(ethBalance.balance, ethAddress) : undefined;
    return _a = {},
        _a[CurrencyTokenSymbol.CTA] = (parsedCtaBalance === null || parsedCtaBalance === void 0 ? void 0 : parsedCtaBalance.base)
            ? {
                usdValue: ((_e = parsedCtaBalance.usd) === null || _e === void 0 ? void 0 : _e.displayValue) || '-',
                value: parsedCtaBalance.base.displayValue,
                availableValue: availableCtaTokenValue,
                lockedValue: lockedCtaTokenValue
                    ? (Number.parseFloat(lockedCtaTokenValue) / 10000000000).toLocaleString('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 4,
                    })
                    : undefined,
            }
            : undefined,
        _a[CurrencyTokenSymbol.USDC] = (parsedUsdcBalance === null || parsedUsdcBalance === void 0 ? void 0 : parsedUsdcBalance.base)
            ? {
                usdValue: ((_f = parsedUsdcBalance.usd) === null || _f === void 0 ? void 0 : _f.displayValue) || '-',
                value: parsedUsdcBalance.base.displayValue,
            }
            : undefined,
        _a[CurrencyTokenSymbol.IMX] = (parsedImxBalance === null || parsedImxBalance === void 0 ? void 0 : parsedImxBalance.base)
            ? {
                usdValue: ((_g = parsedImxBalance.usd) === null || _g === void 0 ? void 0 : _g.displayValue) || '-',
                value: parsedImxBalance.base.displayValue,
            }
            : undefined,
        _a[CurrencyTokenSymbol.ETH] = (parsedEthBalance === null || parsedEthBalance === void 0 ? void 0 : parsedEthBalance.base)
            ? {
                usdValue: ((_h = parsedEthBalance.usd) === null || _h === void 0 ? void 0 : _h.displayValue) || '-',
                value: parsedEthBalance.base.displayValue,
            }
            : undefined,
        _a;
}
export function formatCtaTokenPrice(price) {
    var formatedPrice = price
        .toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
    })
        .replaceAll(',', '')
        .replaceAll('.', '');
    var formatedPriceSuffix = '00000000000000';
    return "".concat(formatedPrice.startsWith('0') ? formatedPrice.substring(1) : formatedPrice).concat(formatedPriceSuffix);
}
